<div class="loader-wrapper">
    <ev-logo-loader width="80px" />
</div>
